"use client";

import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { ORDER_TYPE } from "@/lib/orderType";
import { useCart, useAppDispatch, useCustomer } from "@/store/hooks";
import { openCartDrawer } from "@/store/slices/uiSlice";
import { useStoreSearch } from "@/context/SearchContext";

export default function Header() {
  const { count: groceryCount } = useCart(ORDER_TYPE.GROCERY);
  const { count: takeoutCount } = useCart(ORDER_TYPE.TAKEOUT);
  const { customer } = useCustomer();
  const dispatch = useAppDispatch();
  const { query, setQuery } = useStoreSearch();
  const pathname = usePathname();
  const router = useRouter();

  const hideHeader = pathname?.startsWith("/checkout");

  function handleSubmit(event) {
    event.preventDefault();
    const q = query.trim();
    router.push(
      q ? `/shop/groceries?q=${encodeURIComponent(q)}` : "/shop/groceries",
    );
  }

  if (hideHeader) return null;

  return (
    <>
      <header className="asian-bucket-nav-main-wrapper">
        <div className="asian-bucket-nav-inner-main-wrapper custom-container">
          {/* <button className="asian-bucket-local-service-button" type="button">
            <img src="/assets/icons/location.svg" alt="" />
            <span>Local Pickup &amp; Delivery</span>
          </button> */}

          <div className="asian-bucket-nav-top-row-main-wrapper">
            <Link
              href="/"
              className="asian-bucket-brand-main-wrapper"
              aria-label="Asian Basket home"
            >
              <img
                className="asian-bucket-brand-logo"
                src="/assets/images/logo.jpg"
                alt="Asian Basket"
              />
              <span className="asian-bucket-brand-copy">
                <strong>Asian Basket</strong>
                <small>HOUSE OF INDIAN GROCERIES</small>
              </span>
            </Link>

            <form
              className="asian-bucket-search-main-wrapper"
              onSubmit={handleSubmit}
              role="search"
            >
              <img src="/assets/icons/search.svg" alt="" />
              <input
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="Search for products, brands, or recipes..."
                aria-label="Search products, brands, or recipes"
              />
              <button type="submit" aria-label="Search">
                <img src="/assets/icons/search.svg" alt="" />
              </button>
            </form>

            <nav
              className="asian-bucket-nav-utilities-main-wrapper"
              aria-label="Account and baskets"
            >
              <Link
                href={customer ? "/account" : "/login"}
                className="asian-bucket-nav-utility-button"
                aria-label={
                  customer
                    ? `Signed in as ${customer.first_name || customer.email}`
                    : "Sign in to your account"
                }
              >
                <img src="/assets/icons/user.svg" alt="" />
                <span>
                  {customer?.first_name
                    ? `Hi, ${customer.first_name}`
                    : "Account"}
                </span>
              </Link>

              <button
                type="button"
                className="asian-bucket-nav-utility-button"
                onClick={() => dispatch(openCartDrawer(ORDER_TYPE.GROCERY))}
                aria-label={`Open Grocery Basket with ${groceryCount} items`}
              >
                <span className="asian-bucket-nav-icon-with-count">
                  <img src="/assets/icons/basket.svg" alt="" />
                  {groceryCount > 0 && <b>{groceryCount}</b>}
                </span>
                <span>Grocery Basket</span>
              </button>

              <button
                type="button"
                className="asian-bucket-nav-utility-button"
                onClick={() => dispatch(openCartDrawer(ORDER_TYPE.TAKEOUT))}
                aria-label={`Open Takeout Order with ${takeoutCount} items`}
              >
                <span className="asian-bucket-nav-icon-with-count">
                  <img src="/assets/icons/takeout.svg" alt="" />
                  {takeoutCount > 0 && <b>{takeoutCount}</b>}
                </span>
                <span>Takeout</span>
              </button>
            </nav>
          </div>

          {/* <p className="asian-bucket-brand-tagline">
            More Than Groceries <span>A Taste of Home —</span>
          </p> */}

          <nav
            className="asian-bucket-primary-nav-main-wrapper"
            aria-label="Primary shopping links"
          >
            <Link
              href="/shop/groceries"
              className={pathname === "/shop/groceries" ? "is-active" : ""}
            >
              <img src="/assets/icons/basket.svg" alt="" />
              <span>Groceries</span>
            </Link>
            <Link
              href="/shop/take-out"
              className={pathname === "/shop/take-out" ? "is-active" : ""}
            >
              <img src="/assets/icons/takeout.svg" alt="" />
              <span>Takeout</span>
            </Link>
            <Link
              href="/weekly-specials"
              className={pathname === "/weekly-specials" ? "is-active" : ""}
            >
              <img src="/assets/icons/tag.svg" alt="" />
              <span>Weekly Specials</span>
            </Link>
          </nav>
        </div>
      </header>
    </>
  );
}
